<template>
  <el-container class="ContractForm">
    <el-main class="p-0">
      <el-form
        :model="data"
        :rules="rules"
        inline
        ref="form"
        label-width="80px"
        class="form-label-80"
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="거래처" prop="customer_name">
              <ACustomerSelector
                v-model="data.customer_name"
                seller
                confirmChange
                @select="handleSelectCustomer"
                @clear="handleClearCustomer"
                @acceptedChange="handleAcceptedChangeCustomer"
                @canceledChange="handleCanceledChangeCustomer"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="우편번호" prop="zipcode">
              <el-input
                v-model="data.zipcode"
                class="zipcode readonly"
                readonly
              />
              &nbsp;
              <el-button @click="popupZipcode(handleCompleteZipcode)"
                >우편번호검색</el-button
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="도착지" prop="destination">
              <el-input v-model="data.destination" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item label="연락처" prop="customer_tel">
              <el-input v-model="data.customer_tel" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="수주일" prop="contract_date">
              <ADatePicker v-model="data.contract_date" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="납기일" prop="delivery_date">
              <ADatePicker v-model="data.delivery_date" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="매출일" prop="sale_date">
              <ADatePicker
                v-model="data.sale_date"
                :disabled="data.status_flag === '0' ? false : true"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="출하방법" prop="delivery_way_flag">
              <ADeliveryWaySelector
                v-model="data.delivery_way_flag"
                @change="handleChangeDeliveryWay"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="수주번호" prop="code">
              <el-input v-model="data.code" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-input placeholder="거래처 비고" :value="customerDesc" disabled>
              <template slot="prepend">거래처 비고</template>
            </el-input>
          </el-col>
        </el-row>
      </el-form>
      <ATradeTable
        ref="trade"
        class="mt-default"
        :items="data.details"
        :customer="customer"
        :showGoods="!isNew"
        :delivery_date="data.delivery_date"
        :delivery_way_flag="data.delivery_way_flag"
        :destination="data.destination"
        :charger="data.charger"
        showField
        showSaleOnly
        showSpecification
        showAddition
        @changedSum="handleChangedSum"
        @updated="handleUpdated"
      />
      <el-dialog
        title="견적 가져오기"
        top="10"
        custom-class="form-dialog"
        destroyOnClose
        :close-on-click-modal="false"
        :visible.sync="childdialogVisible"
        :modal="false"
      >
        <EstmationSelectDialog
          :data="form_data"
          @completed="handleCompleted"
          @select="handleSelectEstimation"
        />
      </el-dialog>
      <el-dialog
        custom-class="form-dialog"
        top="0"
        :width="showPyungProcessingCost ? '1200px' : '800px'"
        :title="printOption"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        append-to-body
        destroyOnClose
      >
        <ContractMultiPrint
          ref="print"
          v-if="dialogVisible"
          :title="printOption"
          :data="copiedData"
          :customer="customer"
          @completed="handleCompletePrint"
        />
      </el-dialog>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f4']"
        v-if="!deleted"
        :disabled="sum === 1 || isSale || !has_grant_write"
        :loading="load_button"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
        >{{
          isNew ? $t("button.register") : $t("button.modify")
        }}
        (F4)</el-button
      >
      <el-button v-if="!deleted" @click="handleClickSelectEstimation"
        >견적가져오기</el-button
      >
      <el-button v-if="!deleted" @click="handleClickClear">초기화</el-button>
      <div class="inline print-option ml-default">
        <el-select v-model="printOption">
          <el-option
            v-for="o in printOptions"
            :key="o.value"
            :value="o.value"
          />
        </el-select>
      </div>
      <el-button class="ml-default" @click="handleClickPrint">인쇄</el-button>
      <el-button
        type="danger"
        v-if="!isNew && !deleted"
        :disabled="isSale || !has_grant_write"
        @click="clickDel"
        >삭 제</el-button
      >
      <ACheckboxYN
        v-model="data.direct_sale_flag"
        v-show="isNew"
        style="margin-left: 10px"
        prop="direct_sale_flag"
        >매출 등록</ACheckboxYN
      >
      <ACheckboxYN
        v-model="data.emergency_flag"
        v-show="isNew"
        prop="emergency_flag"
        >긴급 발주</ACheckboxYN
      >
      <div v-if="isProduction" class="inline pl-default">
        <el-tag type="success">생산등록</el-tag>
      </div>
      <div v-if="isSale" class="inline pl-default">
        <el-tag>매출등록</el-tag>
      </div>
      <el-button class="right" @click="closeDialog"
        >{{ $t("button.close") }} (Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>
<script>
import { form } from "@/common/mixins/form";
import { contract_form } from "@/common/mixins/contract_form";
import { zipcode_search } from "@/common/mixins/zipcode_search";
import { company_info } from "@/common/mixins/company_info";
import EstmationSelectDialog from "./EstmationSelectDialog";
import ContractMultiPrint from "./ContractMultiPrint";

export default {
  name: "ContractForm",
  mixins: [form, contract_form, zipcode_search, company_info],
  components: { EstmationSelectDialog, ContractMultiPrint },
  data() {
    return {
      company: {
        show_pyung_processing_cost: false,
      },
      title: this.$t("title.contract_reg"),
      printOption: "견적서",
      childdialogVisible: false,
      dialogVisible: false,
      load_button: false,
    };
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return this.initData();
      },
    },
    deleted: {
      type: Boolean,
      default: false,
    },
    service: {
      type: Object,
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showPyungProcessingCost() {
      return this.company.show_pyung_processing_cost;
    },
    printOptions() {
      return [
        { value: "견적서" },
        { value: "영수증" },
        { value: "거래명세표" },
      ];
    },
    copiedData() {
      return this.util.clone(this.data);
    },
  },
  watch: {
    data: function(val) {
      this.customer = this.table_customer.find((c) => c.id === val.customer_id);
    },
    table_config() {
      this.loadConfig();
    },
  },
  mounted() {
    this.loadConfig();
    if (this.data) {
      this.customer = this.table_customer.find(
        (c) => c.id === this.data.customer_id
      );
    }
  },
  methods: {
    doRegister() {
      let data = Object.assign({}, this.data);
      data.price = this.sum;
      data.details = this.getDetails(true);
      data.price = this.sum;
      data.estimate_date = data.contract_date;

      this.api.selectContract(data.id).then((res) => {
        if (JSON.stringify(res.data) !== "{}" && res.data.status_flag !== "0") {
          this.notifyError(
            "해당 수주에 대한 매출 정보가 이미 등록되었습니다. 수주 정보를 수정할 수 없습니다."
          );
          return;
        } else {
          data.status_flag = res.data.status_flag;
          let api = this.isNew
            ? this.api.createContract
            : this.api.updateContract;
          let message = this.isNew
            ? this.$t("message.success_create")
            : this.$t("message.success_update");
          this.load_button = true;
          api(data).then((res) => {
            this.load_button = false;
            this.handelResponse(res, message);
          });
        }
      });
    },
    doDelete() {
      const data = Object.assign({}, this.data);
      this.api.selectContract(data.id).then((res) => {
        if (JSON.stringify(res.data) !== "{}" && res.data.status_flag !== "0") {
          this.notifyError(
            "해당 수주에 대한 매출 정보가 이미 등록되었습니다. 수주 정보를 삭제할 수 없습니다."
          );
          return;
        } else {
          this.api.deleteContract(data).then((res) => {
            this.handelResponse(res, this.$t("message.success_delete"));
          });
        }
      });
    },
    doEstimationSelect() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.openDialog();
      });
    },
    openDialog() {
      this.childdialogVisible = true;
    },
    handleClickSelectEstimation() {
      this.util.confirm_leave(
        this,
        this.title,
        this.doEstimationSelect,
        "변경사항이 저장되지 않을 수 있습니다. 계속하시겠습니까?"
      );
    },
    handleCompleted(message) {
      this.childdialogVisible = false;
      if (!message) {
        return;
      }
      this.$notify(message);
    },
    clickDel() {
      this.util.confirm_delete(
        this,
        "수주[" + this.data.code + "]",
        this.doDelete
      );
    },
    notifyError(message) {
      this.util.notify_error(this, "수주", message);
    },
    completed(action, message) {
      const options = this.util.get_notify_options("s", "수주", message);
      this.$emit("completed", action, options);
    },
    handleClickClear() {
      this.$refs.trade.clear();
    },
    handleSelectEstimation(new_data) {
      this.data.customer_id = new_data.customer_id;
      this.data.customer_name = new_data.customer_name;
      new_data.details.forEach((d) => {
        d.id = 0;
        this.data.details.push(d);
      });
      this.data.contract_date = this.util.getDateString(this.util.getDate());
      this.data.delivery_date = this.util.getDateString(this.util.getDate(30));
      this.data.destination = new_data.location;
      this.childdialogVisible = false;
    },
    handleClickPrint() {
      this.dialogVisible = true;
    },
    handleCompletePrint() {
      this.dialogVisible = false;
    },
    handelResponse(res, message) {
      if (res.error !== this.system.noError) {
        this.notify_response_error(res);
        return;
      }
      this.util.notify_success(this, this.title, message);
      this.completed(res.data);
    },
    handleClearCustomer() {
      /**
       * ERP-422 수주 등록 페이지 거래처 변경 처리
       * A/S관리에서 수주 등록 되지 않은 항목만 처리
       */
      if (!this.data.service_id) {
        this.customer = null;
        this.data = this.initData();
      }
    },
    handleAcceptedChangeCustomer(param) {
      /**
       * ERP-422 수주 등록 페이지 거래처 변경 처리
       * A/S관리에서 수주등록시, 거래처명만 변경
       */
      if (this.data.service_id) {
        this.data.org_customer_id = param.id;
        this.data.details = [];
      } else {
        this.handleClearCustomer();
      }
      this.handleSelectCustomer(param);
    },
    handleCanceledChangeCustomer(param) {
      /**
       * ERP-422 수주 등록 페이지 거래처 변경 처리
       * A/S관리에서 수주등록시, 입력한 거래처 이름만 변경
       */
      this.data.customer_id = param.id;
      this.data.org_customer_id = param.id;
      this.data.customer_name = param.name;

      if (!this.data.service_id) {
        this.data.customer_tel = param.tel;
        this.data.zipcode = this.util.getCustomerZipcode(param);
        this.data.destination = this.util.getCustomerAddress(param);
      }
    },
  },
};
</script>
